// Apollo
import messageUpdatedGql from "@/Apollo/subscriptions/chat/messageUpdated.graphql";
import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { SubscriptionHookOptions, useSubscription } from "@apollo/client";
import {
  MessageUpdatedSubscription,
  MessageUpdatedSubscriptionVariables,
} from "@whoppah/apollo/schema";

/**
 * Hook for subscribing to the `message updated` event.
 * @param options - Hook typing options.
 * @returns Subscription results.
 */
export const useMessageUpdatedSubscription = (
  options?: SubscriptionHookOptions<
    MessageUpdatedSubscription,
    MessageUpdatedSubscriptionVariables
  >
) => {
  const currency = useDisplayCurrency();

  return useSubscription(messageUpdatedGql, {
    ...withDisplayCurrency(options, currency),
    skip: typeof window === "undefined",
  });
};
